import { zodResolver } from "@hookform/resolvers/zod";
import { Box, Button, CircularProgress, Paper, Stack } from "@mui/material";
import { useSignInMutation } from "Auth/Api/Mutations/useSignInMutation";
import { BlFormInput } from "Forms/Components/BlFormInput";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Logo } from "Shared/Logo";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

const SignUpSchema = z.object({
	login: z.string().email(),
	password: z.string().min(6),
});

type SignUpSchemaType = z.infer<typeof SignUpSchema>;

const PageResources = Resources.SignIn;

type Props = {};

export const SignInForm: FunctionComponent<Props> = () => {
	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm<SignUpSchemaType>({ resolver: zodResolver(SignUpSchema) });

	console.log(errors);
	const { t } = useResource();

	const signInMutation = useSignInMutation();

	const submit = (data: SignUpSchemaType) => {
		signInMutation.mutate(data);
	};

	return (
		<Paper sx={{ px: 4, py: 6 }}>
			<Stack alignItems="center">
				<Stack mb={3}>
					<Logo isDarkLogo={true} />
				</Stack>

				<form onSubmit={handleSubmit(submit)}>
					<BlFormInput
						control={control}
						name="login"
						autoComplete="login"
						errors={errors}
						label={t(PageResources.Login.Label)}
					/>

					<BlFormInput
						control={control}
						name="password"
						errors={errors}
						type="password"
						autoComplete="password"
						label={t(PageResources.Password.Label)}
					/>

					<Box m={2} />

					<Button
						type="submit"
						fullWidth
						color="primary"
						variant="contained"
						disabled={signInMutation.isPending}
					>
						{signInMutation.isPending ? (
							<CircularProgress color="inherit" size={28} />
						) : (
							t(PageResources.Button)
						)}
					</Button>
				</form>
			</Stack>
		</Paper>
	);
};
